/**
 * New navigation.js.
 *
 */
const newNav = document.querySelector('.new-header__nav');
if (newNav) {

    //main menu toggle
    const mainMenuItems = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children a.main-inner');
    Array.from(mainMenuItems).map(elem => {
        elem.addEventListener("click", (event) => {
            event.preventDefault();
            if(elem.parentElement.classList.contains('active')) {
                elem.parentElement.classList.remove('active');
            } else {
                Array.from(newNav.querySelectorAll('li.main-menu-item.menu-item-has-children')).forEach(function(el) { 
                    el.classList.remove('active');
                });
                elem.parentElement.classList.add('active');
            }
        })
    })
    const mainMenuClose = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children a.close-button');
    Array.from(mainMenuClose).map(elem => {
        elem.addEventListener("click", (event) => {
            if(elem.closest('li.main-menu-item.menu-item-has-children').classList.contains('active')) {
                elem.closest('li.main-menu-item.menu-item-has-children').classList.remove('active');
            } else {
                Array.from(newNav.querySelectorAll('li.main-menu-item.menu-item-has-children')).forEach(function(el) { 
                    el.classList.remove('active');
                });
                elem.closest('.li.main-menu-item.menu-item-has-children').classList.add('active');
            }
        });
    })

    //Sub menu toggle
    const itemList = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children .sec-lvl-arrow');
    Array.from(itemList).map(elem => {
        elem.addEventListener("click", (event) => {
            if(elem.parentElement.classList.contains('active')) {
                elem.parentElement.classList.remove('active');
            } else {
                Array.from(newNav.querySelectorAll('.sub-menu-item.menu-item-has-children')).forEach(function(el) { 
                    el.classList.remove('active');
                });
                elem.parentElement.classList.add('active');
            }
        });
    })
    const titleList = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children .sec-lvl-sub-menu__title');
    Array.from(titleList).map(elem => {
        elem.addEventListener("click", (event) => {
            if(elem.closest('.sub-menu-item.menu-item-has-children').classList.contains('active')) {
                elem.closest('.sub-menu-item.menu-item-has-children').classList.remove('active');
            } else {
                Array.from(newNav.querySelectorAll('.sub-menu-item.menu-item-has-children')).forEach(function(el) { 
                    el.classList.remove('active');
                });
                elem.closest('.sub-menu-item.menu-item-has-children').classList.add('active');
            }
        });
    })

    //Third menu toggle 
    const secLvlItems = newNav.querySelectorAll('.sec-lvl-sub-menu__item.menu-item-has-children .third-lvl-arrow');
    jQuery('.third-lvl-sub-menu', newNav).slideUp();
    Array.from(secLvlItems).map(elem => {
        elem.addEventListener("click", (event) => {
            elem.classList.toggle('open');
            elem.parentElement.querySelector('.menu-inner').classList.toggle('open');
            jQuery('.third-lvl-sub-menu', elem.parentElement).slideToggle('slow');
        });
    })
}